export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtVyrobceDisku';
export const NAME = 'VyrobceDisku';
